'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router';
import { useState } from 'react';

import { ExecutionProvider } from '@/lib/storage/provider';

export function Providers({
  children,
}: {
  children: React.ReactNode;
}): import('react/jsx-runtime').JSX.Element {
  const [queryClient] = useState(
    (): QueryClient =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: 1,
            gcTime: 5 * 60 * 1000,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ExecutionProvider>
        <NuqsAdapter>{children}</NuqsAdapter>
      </ExecutionProvider>
    </QueryClientProvider>
  );
}
